import styled, {
  falconTheme,
  IconLabel,
  IconName,
  IDataAttributeMap,
  IFalconComponent,
  mapWithDataPrefix,
  Scale,
  StyledComponent,
} from '@se-admin/falcon';
import * as React from 'react';
import { SaleLabelVariant } from '../SaleLabelList/index';

export interface ISaleLabelTranslations {
  translatedLabelValue?: string;
  translatedTooltipValue?: string;
  translatedTooltipTitle?: string;
}
export interface ISaleLabelProps extends IFalconComponent {
  backgroundColor: string;
  icon?: IconName;
  text?: string;
  saleLabelTranslations?: ISaleLabelTranslations;
  saleLabelVariant?: SaleLabelVariant;
}

const StyledSaleLabel: StyledComponent<'div', {}, ISaleLabelStyleProps> = styled('div')`
  display: inline-flex;
  font-size: 1rem;
  ${({ labelVariant }: ISaleLabelStyleProps) =>
    SaleLabelVariant.small === labelVariant
      ? `margin-right: ${Scale.xs};`
      : `margin-right: ${Scale.xxs};`}
`;

export interface ISaleLabelStyleProps {
  labelVariant: SaleLabelVariant;
}

const SaleLabelFontFamily: StyledComponent<'span', {}, {}> = styled('span')`
  font-family: ${falconTheme.fontFamilyBody.join(', ')};
`;

const SaleLabel: React.FunctionComponent<ISaleLabelProps> = ({
  backgroundColor,
  icon,
  saleLabelTranslations,
  saleLabelVariant,
  dataAttributes,
}) => {
  const saleLabelText: JSX.Element = saleLabelTranslations.translatedLabelValue ? (
    <SaleLabelFontFamily>{saleLabelTranslations.translatedLabelValue}</SaleLabelFontFamily>
  ) : null;

  const dataAttrs: IDataAttributeMap = mapWithDataPrefix(dataAttributes);

  return (
    <StyledSaleLabel labelVariant={saleLabelVariant}>
      <IconLabel
        icon={icon}
        backgroundColor={backgroundColor}
        tooltipText={saleLabelTranslations.translatedTooltipValue}
        tooltipTitle={saleLabelTranslations.translatedTooltipTitle}
        {...dataAttrs}
      >
        {saleLabelText}
      </IconLabel>
    </StyledSaleLabel>
  );
};

export default SaleLabel;
